export const COUNTRIES = 'countries';
export const AREA = 'area';
export const THEMES = 'themes';
export const SUBTHEMES = 'subthemes';
export const TERRITORIES = 'territories';
export const TYPES = 'types';
export const STAGE = 'etapa';
export const TERM = 'term';
export const SOURCE = 'source';
